import MonthDayField from './MonthDayField.component';

export default MonthDayField;